/**
 * 签到
 * @returns
 */
import {
  Box,
  Button,
  Flex,
  IconButton,
  SimpleGrid,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import {
  addMonths,
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
} from "date-fns";
import { useMemo, useState } from "react";
import { SlArrowLeft } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import integralIcon1 from "@/assets/images/sign_icon1.png";
import integralIcon2 from "@/assets/images/sign_icon2.png";
import integralIcon3 from "@/assets/images/sign_icon3.png";
import {
  useGetSignStatusQuery,
  usePostSignMutation,
  useGetSignsQuery,
} from "@/services/api/endpoints/users";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";

const Calendar = () => {
  const user = useSelector(selectUser);
  const userId = user.id;
  const dispatch = useDispatch();
  const toast = useToast();
  const [continuousDay, setContinuousDay] = useState(0);

  const { data: signInRecords, isSuccess: getSignSSuccess } = useGetSignsQuery({
    userId,
  });
  const [postSign, { isSuccess: postSignSuccess }] = usePostSignMutation();
  const { data: signStatus, isSuccess: getSignStatusSuccess } =
    useGetSignStatusQuery({ userId });

  const [currentMonth, setCurrentMonth] = useState(new Date());

  // const [signInRecords, setSignInRecords] = useState<string[]>([
  //   "2024-05-19",
  //   "2024-05-11",
  // ]);

  const currentDay = format(new Date(), "yyyy-MM-dd");

  const handlePrevMonth = () => {
    setCurrentMonth((prevMonth) => addMonths(prevMonth, -1));
  };

  const handleNextMonth = () => {
    setCurrentMonth((prevMonth) => addMonths(prevMonth, 1));
  };

  const handSignIn = async (day: Date) => {
    const today = format(day, "yyyy-MM-dd");
    const isSignIn = signInRecords?.some(
      (obj) => format(obj.create_at, "yyyy-MM-dd") === today
    );
    if (!isSignIn) {
      const result = await postSign({ userId })
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  // 获取当前年月日
  // const currentYear = new Date().getFullYear();
  // const currentMonth = new Date().getMonth();

  // 获取当前月份的天数
  const daysInMonth = useMemo(
    () =>
      eachDayOfInterval({
        start: startOfMonth(currentMonth),
        end: endOfMonth(currentMonth),
      }),
    [currentMonth]
  );

  // 获取当前月份的第一天是周几
  const firstDayOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1
  ).getDay();
  // console.log(firstDayOfMonth, "firstDayOfMonth");

  // 获取上个月的天数
  const daysInLastMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    0
  ).getDate();
  // console.log(daysInLastMonth, "daysInLastMonth");

  // 获取上个月的剩余天数
  const getCalendar = () => {
    let days = [];
    // 填充上个月的剩余天数
    for (let i = 0; i < firstDayOfMonth; i++) {
      let lastday = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() - 1,
        daysInLastMonth - i
      );
      days.push(lastday);
    }
    days.reverse();
    return days;
  };


  return (
    <Box pb="20px">
      <Flex mb="20px" alignItems={"center"} justifyContent="center" gap="20px">
        <IconButton
          aria-label="上一月"
          variant="outline"
          w="24px"
          h="24px"
          borderRadius={"0"}
          size={""}
          p="0"
          borderColor={"#DCE0EB"}
          color={"#8E94A9"}
          fontSize={"12px"}
          icon={<SlArrowLeft />}
          onClick={handlePrevMonth}
        />
        <Box color={"#3D3D3D"} fontSize="18px" fontWeight={"bold"}>
          {format(currentMonth, "yyyy年MM月")}
        </Box>
        <IconButton
          aria-label="下一月"
          variant="outline"
          w="24px"
          h="24px"
          borderRadius={"0"}
          size={""}
          p="0"
          fontSize={"12px"}
          borderColor={"#DCE0EB"}
          color={"#8E94A9"}
          icon={<SlArrowRight />}
          onClick={handleNextMonth}
        />
        {/* <Button onClick={handleNextMonth}>下一月</Button> */}
      </Flex>

      <Box h="1px" bg="#DCE0EB" mb="10px"></Box>

      <SimpleGrid
        spacingX="8px"
        columns={7}
        color="#8E94A9"
        fontSize={"14px"}
        mb="30px"
      >
        {/* 显示星期几的头部 */}
        <Box textAlign={"center"}>日</Box>
        <Box textAlign={"center"}>一</Box>
        <Box textAlign={"center"}>二</Box>
        <Box textAlign={"center"}>三</Box>
        <Box textAlign={"center"}>四</Box>
        <Box textAlign={"center"}>五</Box>
        <Box textAlign={"center"}>六</Box>
      </SimpleGrid>
      {/* 日历 */}
      <SimpleGrid spacingX="8px" spacingY="30px" columns={7}>
        {/* 补充上个月剩余天数 */}
        {getCalendar().map((day) => {
          const isSignIn = signInRecords?.some(
            (obj) =>
              format(obj.create_at, "yyyy-MM-dd") === format(day, "yyyy-MM-dd")
          );
          const isTody = currentDay === format(day, "yyyy-MM-dd");
          return (
            <Box key={`last-${day}`}>
              <Button
                w="100%"
                h="66px"
                p="0"
                borderRadius={"0"}
                boxSizing="border-box"
                _hover={{
                  border: "1px solid #496AE1",
                }}
                isDisabled={!isTody && isSignIn}
              >
                <Flex
                  w="100%"
                  h="100%"
                  gap="5px"
                  flexDirection={"column"}
                  boxSizing="border-box"
                  justifyContent="center"
                  alignItems={"center"}
                  bg={"#EEF1F7"}
                >
                  <Box color={isSignIn ? "#27314D" : "#8E94A9"} fontSize="14px">
                    +5
                  </Box>
                  <Image src={isSignIn ? integralIcon1 : integralIcon2} />
                </Flex>
              </Button>
              <Box
                mt="10px"
                textAlign={"center"}
                color={"#8E94A9"}
                fontSize="14px"
              >
                {format(day, "d")}
              </Box>
            </Box>
          );
        })}
        {/* 显示当前月份的日历 */}
        {daysInMonth.map((day) => {
          const isSignIn = signInRecords?.some(
            (obj) =>
              format(obj.create_at, "yyyy-MM-dd") === format(day, "yyyy-MM-dd")
          );
          const isTody = currentDay === format(day, "yyyy-MM-dd");
          return (
            <Box key={format(day, "yyyy-mm-dd")}>
              <Button
                w="100%"
                h="66px"
                p="0"
                borderRadius={"0"}
                boxSizing="border-box"
                border={isTody ? "1px solid #496AE1" : "none"}
                _hover={{
                  border: "1px solid #496AE1",
                }}
                isDisabled={!isTody && isSignIn}
                // onClick={() => handSignIn(day)}
              >
                <Flex
                  flexDirection={"column"}
                  w="100%"
                  h="100%"
                  gap="5px"
                  justifyContent="center"
                  alignItems={"center"}
                  bg={"#EEF1F7"}
                >
                  <Box
                    color={
                      isSignIn && isTody
                        ? "#496AE1"
                        : isSignIn
                        ? "#27314D"
                        : "#8E94A9"
                    }
                    fontSize="14px"
                  >
                    +5
                  </Box>
                  <Image
                    src={
                      isSignIn && isTody
                        ? integralIcon3
                        : isSignIn
                        ? integralIcon1
                        : integralIcon2
                    }
                  />
                </Flex>
              </Button>

              <Box
                mt="10px"
                textAlign={"center"}
                color={"#8E94A9"}
                fontSize="14px"
              >
                {format(day, "d")}
              </Box>
            </Box>
          );
        })}
      </SimpleGrid>
      {/* <Flex mt="30px" alignItems={"baseline"}>
        <Flex alignItems={"baseline"} color={"#27314D"} fontSize="14px">已连续签到<Text fontSize="22px">1</Text>天，</Flex>
        <Box color={"#8E94A9"} fontSize="12px">再连续签6天，得补签卡；再连续签9天，得优惠券</Box>
      </Flex> */}
    </Box>
  );
};

export default Calendar;
